import React from "react";

const StatisticsSummary = () => <h1>StatisticsSummary</h1>;

export default StatisticsSummary;
